<template >
    <div class="moow-empty-state-container">
        <img v-if="imageUri" class="empty-state-img" :src="imageUri"/>
        <md-icon v-else-if="icon" class="empty-state-icon">{{icon}}</md-icon>
        <p class="moow-header">{{title}}</p>
        <p class="moow-info-txt">{{description}}</p>
        <moow-button
            v-if="ctaButtonText"
            :type="['light']"
            :btnText="ctaButtonText"
            @mClick="ctaClicked"
            :camel="true"
        />

    </div>
</template>


<script>
// Example usage
//  <moow-button :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    imageUri: {
      type: String, 
      required: false
    },
    icon: {
      type: String, 
      required: false
    },
    title: {
      type: String, 
      required: true
    },
    description: {
      type: String, 
      required: false
    },
    ctaButtonText: {
      type: String,
      required: false,
    },
  },
  components: {},
  data() {
    return {};
  },
  filters: {},
  computed: {},
  mounted() {},
  created() {},
  methods: {
    ctaClicked() {
      this.$emit("emitCtaClick");
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/global.css";

    .empty-state-img{
        max-width: 200px;
    }
    .empty-state-icon{
        font-size: 64px !important;
    }
    .moow-empty-state-container{
        margin: 0 auto;
        max-width: 500px;
        text-align: center;
        margin-top: 2em;
        padding: 1em;
    }


</style>



// WEBPACK FOOTER //
// src/components/interface/empty-state/baseEmptyState.vue